import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";

const DirectionCard = ({ title, children }) => (
  <Box
    sx={{
      textAlign: "center",
      px: { xs: 2, md: 3 },
      py: 3,
    }}
  >
    <Typography
      sx={{
        fontFamily: "'Cormorant Garamond', serif",
        fontWeight: 500,
        fontSize: { xs: "1.1rem", md: "1.25rem" },
        letterSpacing: "0.06em",
        color: "var(--clr-primary)",
        mb: 1.5,
      }}
    >
      {title}
    </Typography>
    <Box
      sx={{
        width: 30,
        height: "1px",
        background: "var(--clr-primary)",
        mx: "auto",
        mb: 2,
      }}
    />
    {children}
  </Box>
);

const Arrive = ({ data }) => {
  return (
    <Container maxWidth="lg">
      <Box mb={{ xs: 2, md: 4 }} textAlign="center">
        <Typography
          sx={{
            fontFamily: "'Lato', sans-serif",
            fontWeight: 700,
            fontSize: "0.8rem",
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: "var(--clr-primary)",
          }}
        >
          {data.titles[0].includes("Porto") ? "Como Chegar" : "How to Get Here"}
        </Typography>
      </Box>

      <Grid container spacing={{ xs: 2, md: 4 }}>
        {/* Directions from cities */}
        {data.titles.slice(0, 3).map((title, id) => (
          <Grid item xs={12} md={4} key={id}>
            <DirectionCard title={title}>
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  lineHeight: 1.9,
                  color: "#4a4a4a",
                }}
              >
                {data.contents[id]}
              </Typography>
            </DirectionCard>
          </Grid>
        ))}
      </Grid>

      {/* GPS Coordinates */}
      <Box mt={{ xs: 2, md: 4 }}>
        <DirectionCard title={data.titles[3]}>
          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "#4a4a4a",
              lineHeight: 1.9,
              fontFamily: "'Lato', sans-serif",
            }}
          >
            {data.contents[3]}
          </Typography>
          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "#4a4a4a",
              lineHeight: 1.9,
              fontFamily: "'Lato', sans-serif",
            }}
          >
            {data.contents[4]}
          </Typography>
        </DirectionCard>
      </Box>
    </Container>
  );
};

export default Arrive;
